import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { FinialFinishType } from "@/models/configurator/configurator_options";

export const formatTitle = (title: string, part: string): string => {
  let result = "";
  if (title.indexOf(" ")) {
    if (part == "a") {
      result = title.substr(0, title.indexOf(" "));
    } else {
      result = title.substr(title.indexOf(" ") + 1);
    }
  } else {
    return title;
  }
  return result;
};

export const getImg = (img: string): string => {
  return img + "?width=285";
};

/**
 * The quote multiplier for a price-level discount: `1 + discountpct`, rounded to
 * 4 decimals. The rounding is not cosmetic — `1 + (-0.57)` is `0.43000000000000005`
 * in IEEE-754, and that raw float was being stamped onto every line's
 * `multiplier` (and rendered raw) so the artifact showed up in the cart and the
 * Add-to-Cart modal. Which discounts land on an ugly float is value-dependent
 * (`-0.61` → a clean `0.39`), which is why it surfaced "out of nowhere" for one
 * customer. Every `1 + discountpct` in the app should route through here so the
 * value is consistent whether it's displayed or written to a line. `null`/absent
 * discount ⇒ `1`.
 */
export const priceLevelMultiplier = (
  discountpct?: number | null
): number => {
  if (discountpct == null) return 1;
  return parseFloat((1 + discountpct).toFixed(4));
};

export const makeTitleCase = (option: string) => {
  return option
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ")
    .replaceAll("_", " ")
    .replaceAll("-", " ");
};

export const getFinishImage = (handle: string | FinishHandle): string => {
  let img = "";
  for (const value in FinishHandle) {
    if (handle === "msa" || handle === "ss" || handle === "gs") {
      img = require(`../assets/images/finishes/ms.png`);
    } else if (FinishHandle[value] === handle) {
      img = require(`../assets/images/finishes/${handle}.png`);
    }
  }
  return img;
};

export const getFinishName = (
  stringHandle: FinishHandle
): FinishDisplayName => {
  const handle = stringHandle as FinishHandle;
  let name = "" as FinishDisplayName;
  switch (handle) {
    case FinishHandle.MS:
      name = FinishDisplayName.MS;
      break;
    case FinishHandle.WG:
      name = FinishDisplayName.WG;
      break;
    case FinishHandle.BK:
      name = FinishDisplayName.BK;
      break;
    case FinishHandle.WH:
      name = FinishDisplayName.WH;
      break;
    case FinishHandle.BZ:
      name = FinishDisplayName.BZ;
      break;
    case FinishHandle.SR:
      name = FinishDisplayName.SR;
      break;
    case FinishHandle.HW:
      name = FinishDisplayName.HW;
      break;
    case FinishHandle.MSA:
      name = FinishDisplayName.MSA;
      break;
    case FinishHandle.SM:
      name = FinishDisplayName.SM;
      break;
    case FinishHandle.SS:
      name = FinishDisplayName.SS;
      break;
    case FinishHandle.GS:
      name = FinishDisplayName.GS;
      break;
    case FinishHandle.ASH:
      name = FinishDisplayName.ASH;
      break;
    case FinishHandle.GBK:
      name = FinishDisplayName.GBK;
      break;
  }
  return name;
};

export const getFinialFinishDisplayName = (
  finishType: FinialFinishType | null
): string => {
  switch (finishType) {
    case FinialFinishType.TPU:
      return "TPU Match";
    case FinialFinishType.CH:
      return "Chrome";
    case FinialFinishType.SS:
      return "Stainless Steel";
    default:
      return finishType ?? "";
  }
};
